import { ServicesSection } from "./ServicesSection";
import "./services.scss";
import React from "react";
import AndroidSvg from "./images/android.svg";
import web from "./images/web.svg";
import api from "./images/api.svg";
import b2b from "./images/b2b.svg";
import security from "./images/security.svg";
import technical from "./images/technical.svg";
import sourceCode from "./images/SourceCode.svg";
// import security from "./images/security.svg";

export const Services = () => {
  return (
    <React.Fragment>
      <ServicesSection
        type="one"
        backgroundColor={"BC98DF"}
        title={"Android/IOS Application Development"}
        description={
          "We provide our customers with the chance to interact with cutting-edge technologies and experienced tech professionals. Simultaneously, we specialize in native and cross-application development (React Native) for both Android and iOS platforms."
        }
        image={AndroidSvg}
      />

      <ServicesSection
        type="two"
        backgroundColor={"rgba(141, 132, 238, 1)"}
        title={"Web Development"}
        description={
          "Discover unparalleled web development services tailored to meet your business needs. From concept to deployment, we specialize in crafting innovative solutions that enhance user experiences, drive online presence, and optimize business operations. Our expert team ensures a seamless and efficient development journey, empowering your digital success."
        }
        image={web}
      />

      <ServicesSection
        type="one"
        backgroundColor={"BC98DF"}
        title={"API Development & Integrations"}
        description={
          "Unlock seamless connectivity and enhance your digital ecosystem with our specialized API development services. We create robust and efficient APIs tailored to your unique needs, ensuring smooth integration and optimized performance for your applications and systems."
        }
        image={api}
      />

      <ServicesSection
        type="two"
        backgroundColor={"rgba(141, 132, 238, 1)"}
        title={"B2B/A2A System Integrations"}
        description={
          "Streamline your business operations with our expertise in B2B (Business-to-Business) and A2A (Application-to-Application) system integrations. We design and implement seamless connections between systems, enhancing efficiency and communication for a cohesive and interconnected business environment."
        }
        image={b2b}
      />

      <ServicesSection
        type="one"
        backgroundColor={"BC98DF"}
        title={"IT Security Services"}
        description={
          "Our comprehensive threat audits enable us to uncover the most critical vulnerabilities in your infrastructure. This insight empowers us to implement the encryption and protocols you need, delivering cutting-edge cybersecurity services. Backed by in-depth analysis and a strong technical background, we conduct real-world attack simulations to assess the actual impact and security status, ensuring a robust defense against potential threats. "
        }
        image={security}
      />

      <ServicesSection
        type="two"
        backgroundColor={"rgba(141, 132, 238, 1)"}
        title={"Technical Support"}
        description={
          "Our dedicated team provides end-to-end Technical support services to ensure the seamless operation and security of your systems. From troubleshooting to proactive maintenance, we are committed to keeping your IT infrastructure optimized and your business running smoothly. "
        }
        image={technical}
      />

      <ServicesSection
        type="one"
        backgroundColor={"BC98DF"}
        title={"You Own The Source Code"}
        description={
          "Full Source Code Ownership: Your ownership of the source code is absolute. This ensures you have complete control and flexibility for future development and maintenance of your software solutions."
        }
        image={sourceCode}
      />
    </React.Fragment>
  );
};
